import {keyBy, merge, values} from 'lodash'

const mergeObjectByKey = (left, right, key) => {
  return {
    ...left,
    details: values(merge(keyBy(left.details, key), keyBy(right, key)))
  };
}

const mergeArrayByKey = (left, right, key) => {
  return values(merge(keyBy(left, key), keyBy(right, key)));
}

export {mergeObjectByKey, mergeArrayByKey};